import React from 'react';
import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="py-24 relative overflow-hidden" data-testid="cta-section">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-secondary/10" />
      <div className="absolute inset-0 bg-dots opacity-20" />
      
      <div className="container-custom relative z-10">
        <motion.div
          className="text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter uppercase text-white mb-6">
            JOIN THE <span className="gradient-text">SQUAD</span>
          </h2>
          <p className="text-muted-foreground text-lg mb-10 max-w-2xl mx-auto">
            Download Playmatez today and become part of India's fastest-growing sports community. 
            Your next game is just a tap away.
          </p>

          {/* Download Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <motion.a
              href="https://play.google.com/store/apps/details?id=com.app.playmatez&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              data-testid="cta-google-play-btn"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" 
                alt="Get it on Google Play" 
                className="h-14"
              />
            </motion.a>

            <motion.a
              href="https://apps.apple.com/app/playmatez/id6450857903"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              data-testid="cta-app-store-btn"
            >
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" 
                alt="Download on the App Store" 
                className="h-14"
              />
            </motion.a>
          </div>

          {/* QR Code */}
          <div className="inline-flex items-center gap-4 p-4 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20">
            <div className="bg-white p-3 rounded-xl">
              <img
                src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://download.playmatez.io/u/F4AE8rel&bgcolor=ffffff&color=000000"
                alt="Download Playmatez QR Code"
                className="w-20 h-20"
                data-testid="cta-qr-code"
              />
            </div>
            <div className="text-left">
              <p className="text-white font-semibold text-sm">Scan to Download</p>
              <p className="text-muted-foreground text-xs">Point your camera at the QR code</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
